// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--33iL9";
export var OptionTitle = "styles-module--OptionTitle--PSwfl";
export var OptionName = "styles-module--OptionName--8umd2";